module.exports = __webpack_public_path__ + "img/Amblem2-1@2x.5ad3750d.webp";